/**
 * Created by SH: 20/02/2020
 */

import { PunkSymbolData } from "./symbol/PunkSymbolData";
import { PREnginePlayer } from "./PREnginePlayer";
import { PunkSymbol } from "./symbol/PunkSymbol";
import { ReelEngineController } from "../../core/reel/ReelEngineController";
import { GameSetting } from "../../core/setting/GameSetting";

export class PREngineView extends ReelEngineController {

    protected attentionStop: boolean = false;

    public moveYOffsetOld:number = 0;
    public moveYOffsetNew:number = 0;

    public get engine(): PREnginePlayer { return this._engine as PREnginePlayer; }

    public get AllSymbols(): PunkSymbol[] { return this._symbolContainer.children as PunkSymbol[]; }

    public get topSymbol(): PunkSymbol { return this.AllSymbols[0]; }
    public get bottomSymbol(): PunkSymbol { return this.AllSymbols[this.AllSymbols.length - 1]; }

    public get windowTopSymbol(): PunkSymbol { return this.AllSymbols[this.overflowAmount] }
    public get windowBottSymbol(): PunkSymbol { return this.AllSymbols[this.AllSymbols.length - (1 + this.overflowAmount)]; }

    public get AllWindowSymbols(): PunkSymbol[] {
        return this.AllSymbols.filter(sym => { return (Math.max(...sym.posID) >= 0 && Math.min(...sym.posID) < (this.AllSymbols.length - (1 + this.overflowAmount))) });
    }

    public get stopDuration(): number {
        if (GameSetting.isFastSpin) return this.config.DURATION.FAST_STOP;
        else if (this.attentionStop) return this.config.DURATION!.ATTENTION_STOP!;
        return this.config.DURATION.STOP;
    }

    public get stopDelay(): number {
        if (GameSetting.isFastSpin) return this.config.DELAY.FAST_STOP;
        return this.config.DELAY.STOP;
    }

    // public get startDuration(): number {
    //     return (GameSetting.isFastSpin ? this.config.DURATION.FAST_START : this.config.DURATION.START) / PunkSymbolData.fetchSizeTimesSize(this.config.WINDOW_AMOUNT);
    // }

    public get spinDuration(): number {
        return (GameSetting.isFastSpin ? this.config.DURATION.FAST_SPIN : this.config.DURATION.SPIN) / PunkSymbolData.fetchSizeTimesSize(this.config.WINDOW_AMOUNT);
    }

    createReelEngine(): void {
        this._engine = new PREnginePlayer(this.engineCallbacks(), this._animationContainer);
        this._engine.stepDistance = this.maxHeight/this.config.WINDOW_AMOUNT;
    }

    protected checkSymbolBoundries(symbolToCheck: PunkSymbol, inside: boolean, reverse: boolean): boolean {

        let posY: number = symbolToCheck.position.y + ((reverse ? 1 : -1) * (symbolToCheck.symbolHeight));

        const engineStep: number = Math.abs(this.engine.stepDistance);
        const sizeMatter:number = symbolToCheck.symbolHeight;
        const overflowOffset: number = sizeMatter * this.overflowAmount;

        const stepDistanceOffset = 180 - engineStep;
        const fromDirection: number = stepDistanceOffset + overflowOffset;
        const toDirection: number = -stepDistanceOffset + (this.maxHeight - engineStep) + overflowOffset;

        // Check if it is visible by Restriction and symbol size.
        let fromTop: boolean = false;
        let fromBott: boolean = false;

        if (inside) {
            fromTop = (!reverse && posY >= -fromDirection)
            fromBott = (reverse && posY <= toDirection);
        } else {
            fromTop = (reverse && posY <= -fromDirection)
            fromBott = (!reverse && posY >= toDirection);
            if (fromTop || fromBott) (fromTop ? this.AllSymbols.shift() : this.AllSymbols.pop())!.remove();
        }

        return fromTop || fromBott;
    }

    protected createNewSymbol(id: number, symbolName: string, state?: string, type?: number): PunkSymbol { return new PunkSymbol(id, symbolName,state,type ? type : 7 - this.windowConfAmount); }
    // protected createNewSymbol(id: number, symbolName: string, state?: string): PunkSymbol {
    //     return new PunkSymbol(id, symbolName, state);
    // }
}
